import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { history, apiService } from "_helpers";
import { CenterAddressModal, CenterConfigModal, CenterCreditModal, CenterStudyRateModal } from "_components";

export { CenterSetting };

function CenterSetting() {
  const { user: authUser } = useSelector((x) => x.auth);
  const dispatch = useDispatch();
  const [centerList, setCenterList] = useState([]);
  const [filteredCenterList, setFilteredCenterList] = useState([]);
  const [doctorList, setDoctorListData] = useState([]);
  const [agentList, setAgentListData] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [showCreditModal, setShowCreditModal] = useState(false);
  const [showStudyRateModal, setShowStudyRateModal] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [modifiedCenters, setModifiedCenters] = useState([]);

  const closeClick = (event) => {
    history.navigate("/home");
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getCenterList(), getDoctorList(), getAgentList()]);
    };
    fetchData();
  }, []);

  const getCenterList = async () => {
    if (!authUser) return null;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetCenterList?user_key=`+user_key.toString();
    const data = await apiService.get(url, dispatch);
    console.log(data);
    if (Array.isArray(data) && data.length > 0) {
      setCenterList(data);
    }
  };

  const getDoctorList = async () => {
    if (!authUser) return null;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetDoctorList?user_key=`+user_key.toString();
    const data = await apiService.get(url, dispatch);
    if (Array.isArray(data) && data.length > 0) {
      setDoctorListData(data);
    }
  };

  const getAgentList = async () => {
    if (!authUser) return null;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetAgentList?user_key=`+user_key.toString();
    const data = await apiService.get(url, dispatch);
    if (Array.isArray(data) && data.length > 0) {
      setAgentListData(data);
    }
  };

  const handleEditAddress = (center) => {
    setSelectedCenter(center);
    setShowAddressModal(true);
  };

  const handleEditConfig = (center) => {
    setSelectedCenter(center);
    setShowConfigModal(true);
  };

  const handleEditCredit = (center) => {
    setSelectedCenter(center);
    setShowCreditModal(true);
  };
  const handleEditStudyRate = (center) => {
    setSelectedCenter(center);
    setShowStudyRateModal(true);
  };

  const handleModalSave = async (updatedFields, updateType) => {
    if (!selectedCenter) return;
    // Merge updated fields into the selected center
    const updatedCenter = {
      ...selectedCenter,
      ...updatedFields,
      update_type: updateType,
    };
    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterList`;
      // Send only the updated center as an array
      const response = await apiService.post(url, [updatedCenter], dispatch);
      if (response?.success) {
        setSelectedCenter(null);
        setShowStudyRateModal(false);
        setShowCreditModal(false);
        setShowConfigModal(false);
        setShowAddressModal(false);
        setCenterList((prevList) =>
          prevList.map((center) =>
            center.center_key === updatedCenter.center_key
              ? { ...center, ...updatedFields }
              : center
          )
        );
        alert("Center updated successfully.");
      } else {
        alert("Failed to update center. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while updating center.");
    }
  };

  const handleSearchChange = (event) => {
    var filterColName = event.target.id;
    var filterColValue = String(event.target.value).toLowerCase();

    if (filterColValue) {
      const filteredData = centerList.filter((center) =>
        String(center[filterColName]).toLowerCase().includes(filterColValue)
      );
      setFilteredCenterList(filteredData);
    } else {
      setFilteredCenterList([]);
    }
  };
  const updateCenter = async (event) => {
    console.log(modifiedCenters);
    if (!Array.isArray(modifiedCenters) || modifiedCenters.length === 0) {
      console.warn("No modified centers to send.");
      alert("No modified centers to send.");
      return;
    }

    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterList`;
      const response = await apiService.post(url, modifiedCenters, dispatch);

      if (response?.success) {
        console.log("Centers updated successfully:", response);
        alert("Center updates saved to database.");
        getCenterList();
        setModifiedCenters([]);
      } else {
        console.error(
          "Failed to update centers:",
          response?.message || response
        );
        alert("Failed to save changes. Please try again.");
      }
    } catch (error) {
      console.error("Error while sending centers to database:", error);
      alert("An unexpected error occurred while saving.");
    }
  };

  const handleChange = (center_key, event) => {
    const { name, value } = event.target;

    setCenterList((prevList) =>
      prevList.map((center) =>
        center.center_key === center_key ? { ...center, [name]: value } : center
      )
    );

    setModifiedCenters((prev) => {
      const exists = prev.find((c) => c.center_key === center_key);
      const updated = {
        ...(exists || centerList.find((c) => c.center_key === center_key)),
        [name]: value,
      };

      return exists
        ? prev.map((c) => (c.center_key === center_key ? updated : c))
        : [...prev, updated];
    });
  };

  return (
    <div className="tele-body">
      <main>
        <div className="container-fluid px-4">
          <div className="row">
            <div className="col-12 col-lg-8 col-md-8 col-sm-8 mt-2">
              <h5 className="text-blue font-roboto font-weight700">
                <small>Center Setting </small>
              </h5>
            </div>
            <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
              {/* <button
                type="button"
                className="btn btn-secondary btn-sm btn-block text-light bi bi-plus-square"
                name="Save"
                onClick={updateCenter}
              >
                {" "}
                SAVE
              </button> */}
            </div>
            <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
              <button
                type="button"
                className="btn btn-dark btn-sm btn-block text-light bi bi-x-circle"
                name="Close"
                onClick={closeClick}
              >
                {" "}
                CLOSE
              </button>
            </div>
          </div>

          <hr className="mt-0" />

          <div className="row">
            <div className="col-md-12 mb-2">
              <div className="card">
                <div className="card-header bg-gradient-1 text-light">
                  {/* Table Heading */}
                  <div className="row">
                    <div className="col-3 col-sm-1 col-md-1">
                      <p className="tele-table-heading">
                        <i
                          className="bi bi-arrow-down" /*onClick={event => sortClick(event, 'template_id') }*/
                        ></i>{" "}
                        Id{" "}
                      </p>
                      <input
                        type="text"
                        className="form-control form-control-sm tele-table-searcharea"
                        id="center_id"
                        onChange={handleSearchChange}
                        placeholder=""
                      />
                    </div>
                    <div className="col-4 col-sm-3 col-md-3">
                      <p className="tele-table-heading">
                        <i
                          className="bi bi-arrow-down icon-muted" /*onClick={event => sortClick(event, 'template_name') }*/
                        ></i>
                        Center Name
                      </p>
                      <input
                        type="text"
                        className="form-control form-control-sm tele-table-searcharea"
                        id="center_name"
                        onChange={handleSearchChange}
                        placeholder=""
                      />
                    </div>
                    <div className="col-sm-2 col-md-2 d-none d-sm-block">
                      <p className="tele-table-heading">Interval Time Gap</p>
                    </div>
                    <div className="col-sm-4 col-md-4 d-none d-sm-block">
                      <p className="tele-table-heading">Default Doctor</p>
                    </div>
                  </div>
                </div>
                <div className="card-body tele-table-padding centerlist-area">
                  {/* tele-table-rowbg1 */}
                  <div className="row centerlist" id="divCenterSetting"></div>
                  {(filteredCenterList.length > 0
                    ? filteredCenterList
                    : centerList
                  ).map((data, i) => (
                    <div key={i} className="row align-items-center studylist">
                      <div className="col-2 col-sm-3 col-md-1">
                        <p className="tele-table-dash-text">{data.center_id}</p>
                      </div>
                      <div className="col-8 col-sm-3 col-md-3">
                        <p className="tele-table-dash-text">{data.center_name}</p>
                      </div>
                      <div className="col-2 col-sm-2 col-md-2 d-none d-sm-block">
                        <p className="tele-table-dash-text">
                          {data.interval_time_gap}
                        </p>
                      </div>

                      <div className="col-8 col-md-4 mt-2 mt-md-0">
                        <p className="tele-table-dash-text">
                          {doctorList.find(
                            (doctor) =>
                              doctor.doctor_key === data.default_doctor_key
                          )?.doctor_name || ""}
                        </p>
                      </div>

                      <div className="col-4 col-sm-2 col-md-2">
                        <button
                          type="button"
                          className="btn btn-outline-warning btn-sm bi bi-pencil-fill m-1"
                          title="Edit Address"
                          onClick={() => handleEditAddress(data)}
                        ></button>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm bi bi-gear-fill m-1"
                          title="Edit Config"
                          onClick={() => handleEditConfig(data)}
                        ></button>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm bi bi-credit-card-2-front m-1"
                          title="Edit Credit Control"
                          onClick={() => handleEditCredit(data)}
                        ></button>

                        {(authUser?.user_type === 'S' || authUser?.user_key === 1) ? 
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm bi bi-card-checklist m-1"
                              title="Edit Study Rate"
                              onClick={() => handleEditStudyRate(data)}
                            ></button>
                          : <span style={{display:"none"}}></span>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {showAddressModal && (
          <CenterAddressModal
            show={showAddressModal}
            onClose={() => setShowAddressModal(false)}
            centerData={selectedCenter}
            onSave={(fields) => handleModalSave(fields, "A")}
          />
        )}
        {showConfigModal && (
          <CenterConfigModal
            show={showConfigModal}
            centerData={selectedCenter}
            doctorList={doctorList}
            onClose={() => setShowConfigModal(false)}
            onSave={(fields) => handleModalSave(fields, "C")}
          />
        )}    
        {showCreditModal && (
          <CenterCreditModal
            show={showCreditModal}
            centerData={selectedCenter}
            agentList={agentList}
            onClose={() => setShowCreditModal(false)}
            onSave={(fields) => handleModalSave(fields, "D")}
          />
        )}
        {showStudyRateModal && (
          <CenterStudyRateModal
            show={showStudyRateModal}
            centerData={selectedCenter}
            onClose={() => setShowStudyRateModal(false)}            
          />
        )}    
      </main>
    </div>
  );
}
